import moment from 'moment';

export function formatEventDate(date) {
  if (!date) return null;
  const parsed = moment(date);
  if (!parsed.isValid()) return null;
  return parsed.format('D MMM YYYY');
}

export function formatEventDuration(duration) {
  if (duration === null || duration === undefined || duration === '') return null;
  const days = Number(duration);
  if (Number.isNaN(days)) return null;
  return `${days} ${days === 1 ? 'day' : 'days'}`;
}

export function formatEventDateAndDuration(date, duration) {
  const formattedDate = formatEventDate(date);
  const formattedDuration = formatEventDuration(duration);
  if (formattedDate && formattedDuration) {
    return `${formattedDate} · ${formattedDuration}`;
  }
  return formattedDate || formattedDuration || null;
}

export function formatEventWebsite(website) {
  if (!website) return null;
  return String(website)
    .replace(/^https?:\/\//i, '')
    .replace(/\/$/, '');
}

export function toIsoDate(dateValue) {
  if (!dateValue) return null;
  if (typeof dateValue.toISOString === 'function') {
    return dateValue.toISOString();
  }
  const parsed = moment(dateValue);
  if (!parsed.isValid()) return null;
  return parsed.toISOString();
}

export function getEventDetailPath(eventId) {
  return `/events/${eventId}/workflows`;
}

export function getEventAgentsPath(eventId) {
  return `/events/${eventId}/agents`;
}

export function getEventBrandingPath(eventId) {
  return `/events/${eventId}/branding`;
}

export function getEventLeadsPath(eventId) {
  return `/events/${eventId}/leads`;
}

export function getEventWorkflowAgentsPath(eventId, workflowKey) {
  return `/events/${eventId}/workflows/${workflowKey}`;
}

export function getEventContextPath(eventId, workflowKey) {
  if (eventId && workflowKey) {
    return getEventWorkflowAgentsPath(eventId, workflowKey);
  }
  if (eventId) {
    return getEventDetailPath(eventId);
  }
  return '/events';
}
